import { render, staticRenderFns } from "./CustomWheelEditor.vue?vue&type=template&id=1cef472e&scoped=true&"
import script from "./CustomWheelEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomWheelEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CustomWheelEditor.vue?vue&type=style&index=0&id=1cef472e&lang=scss&scoped=true&"
import style1 from "./CustomWheelEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cef472e",
  null
  
)

export default component.exports